// extracted by mini-css-extract-plugin
export default {"hideTooltip":"P8-z","fadeIn":"Q8-z","delay":"R8-z","recommendedSizeTooltip":"S8-z"};